import { Box, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function EmptyDemandMessage({ label }) {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 1.5,
                py: 1,
                border: "1px dashed",
                borderColor: "divider",
                borderRadius: 1,
                color: "text.disabled",
            }}
        >
            <Iconify icon="mdi:flag-outline" width={20} />
            <Typography variant="body2">{label}</Typography>
        </Box>
    )
}
